<template>
    <v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Enviar solicitud de factura
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-card>
                                    <v-card-title>
                                        Reportes
                                    </v-card-title>
                                    <v-data-table :headers="headres2"
                                                  hide-default-footer
                                                  :items="selected">
                                        <template v-slot:body.append>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td>Total:</td>
                                                <td>
                                                    {{total}}
                                                </td>
                                                <td colspan="4"></td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                            
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <label class="typo__label" style="color: black; text-align: center;">Fecha:</label>
                                <v-menu ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dateFormatted"
                                                      outlined
                                                      readonly
                                                      v-bind="attrs"
                                                      @blur="date = parseDate(dateFormatted)"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date"
                                                   locale="es-mx"
                                                   :max="maxfecha"
                                                   :min="mindate"
                                                   @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-form ref="frm" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <label class="typo__label" style="color: black; text-align: center;">Contrarecibo:</label>
                                    <v-text-field v-model="contrarecibo"
                                                  outlined
                                                  @keypress="filter($event)"
                                                  
                                                  :rules="reglamonto"
                                                  name="iput-12"></v-text-field>
                                    <span v-if="valicon == true" style="color:red; font-size:12px; font-weight: 700">{{error}}</span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <span style="color: black; text-align: center;">Observaciones:</span>
                                    <v-textarea :counter="500"
                                                :rules="rulestextarea"
                                                outlined
                                                v-model="comentarios"
                                                required
                                                name="input-7-4"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       color="primary" @click="Guardar()">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" color="error" @click="Regresar()">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import servicio from '@/services/TramitePago/TramitePago.Service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import { Validator } from "vee-validate";

    export default {
        title() {
            return this.$route.meta.title
        },
        data: vm => ({
            valid: true,
            maxfecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            menu1: false,
            headres2: [
                { text: 'Reporte', value: 'nrreporte', class: "text title" },
                { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                { text: 'Cliente', value: 'Cliente', class: 'text title' },
                { text: 'Monto', value: 'tpmonto', class: 'text title' },
                { text: 'Fecha del Reporte', value: 'svfhreporte', class: "text title" },
            ],
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            reglamonto: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v < 1) {
                        // return 'El contrarecibo ya existe, no se puede duplicar'
                        return 'El contrarecibo debe ser mayor a 0';
                    }
                    
                    else
                        return true
                }
            ],
            mindate: '',
            comentarios: '',
            total: 0,
            contrarecibo: '',
            overlay: false,
            valicon: false,
            validc: false,
            erro: ''
        }),
        props: ['selected'],
        watch: {
            validDocs(val) {
                if (val == true) {
                    document.getElementById("dropzError").style.display = "none";
                } else {
                    document.getElementById("dropzError").style.display = "block";
                }
            },
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            },
            overlay(val) {
                val && setTimeout(() => {
                    this.overlay = false
                }, 2000)
            },
            'contrarecibo': function () {
                this.ValidarContrarecibo();
            }
        },
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        methods: {
            async ValidarContrarecibo() {
                if (this.contrarecibo != 0) {
                    let formdata = new FormData();
                    formdata.append("contrarecibo", this.contrarecibo);
                    let datos = await servicio.ValidarContrarecibo(this, formdata);
                    console.log(datos, this.contrarecibo);
                    this.valicon = datos.valida;
                    this.error = datos.msg;
                }
                else {
                    this.valicon = 0;
                    this.error = '';
                }
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();

                if (!/^[-+]?[0-9]*?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            Regresar() {
                this.$router.push({ name: `EnvioFacturas` });
            },
            Limpiar() {
                this.comentarios = '';
                this.contrarecibo = '';
                this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            },
            /////
            Guardar() {
                this.comentarios = this.comentarios.trim();
                if (this.comentarios.length > 0)
                    this.comentarios = this.comentarios.replace(/\s*$/, "");
                this.ValidarContrarecibo();
                if (this.$refs.frm.validate() && this.comentarios.length >= 12 && !this.valicon) {

                    let formdata = new FormData();
                    formdata.append("datos", JSON.stringify(this.selected));
                    formdata.append("contrarecibo", this.contrarecibo);
                    formdata.append("fecha", this.date);
                    formdata.append("obs", this.comentarios);
                    this.$swal({
                        title: "Guardando, espere un momento...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    this.$swal.showLoading();
                    servicio.GuardarEnvioFactura(this, formdata).then(data => {
                        if (data[0].success == "true") {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito",
                                text: "Los reportes han sido enviados",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 2000,
                                confirmButtonText: "Ok!",
                            }).then(() => {
                                this.$router.push({ name: `EnvioFacturas` });
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error",
                                text: "No se puede guardar, por favor, intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                confirmButtonText: "Ok!",
                            });
                        }
                    })
                }
            },
            formatomoneda(valor) {
                var num = valor;
                var prefix = prefix || '';
                var splitStr = num.split('.');
                var splitLeft = splitStr[0];
                var splitRight = splitStr.length > 1 ? '.' + splitStr[1] : '';
                var regx = /(\d+)(\d{3})/;
                while (regx.test(splitLeft)) {
                    splitLeft = splitLeft.replace(regx, '$1' + ',' + '$2');
                }
                if (splitRight == '') { splitRight = '.00' }
                if (splitLeft == '') { splitLeft = '0' }
                var resultado = prefix + splitLeft.toString() + splitRight.substring(0, 3);

                if (resultado == "0.00" || resultado == "$ 0.00" || resultado == "")
                    this.total = '$ 0.00';
                else
                    this.total = '$ ' + resultado.toString();
            }
        },
        mounted() {
            this.overlay = true

            if (this.selected == null)
                this.Regresar();
            else {
                let mayor = Math.max(...this.selected.map(x => parseInt(x.Row)));
                let datos = this.selected.filter(x => x.Row == mayor);
                this.mindate = this.parseDate(datos[0].xpfecha);
            }
            for (let x in this.selected) {
                this.total += parseFloat(this.selected[x].tpmonto.replace(/([^0-9\.\-])/g, ''));//Ahora que es un objeto javascript, tiene propiedades
            }
            this.total = MetodosGenerales.regresarValorMoneda(this.total, '$');
        },
        beforeMount() {
           
        }
    }
</script>
<style>
    .multiselect--active {
        z-index: 9999 !important;
    }

    .border-error {
        border-color: red;
    }

    .dz-preview {
        width: 150px;
    }
</style>